import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { getTransactionListSuccess, getTransactionListFailure } from "../../Action";
import { TRANSACTION_LIST } from "../../Action/actionTypes";
import { notifyError } from "../../../Utils/Helper";

function* allTransactionsListRequest(action) {
  try {
    const { per_page, page, date_from, date_to, status, type,whitelabelId } = action?.payload?.payload || {};
    const { data } = yield API.get(
      `/transactions-list?per_page=${per_page}&page=${page}&start_date=${date_from}&end_date=${date_to}&status=${status}&type=${type}&whitelabelId=${whitelabelId}`
    );
   

    if (data?.meta?.code === 200) {
      yield put(getTransactionListSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(getTransactionListFailure());
      notifyError("Invalid Request.");
    }
  } catch (error) {
    yield put(getTransactionListFailure());
    notifyError("Invalid Request.");
  }
}

export function* watchAllTransactionsListAPI() {
  yield takeEvery(TRANSACTION_LIST, allTransactionsListRequest);
}

export default function* rootSaga() {
  yield all([watchAllTransactionsListAPI()]);
}
